import { UpdateChatbotDrawer } from './update-chatbot-drawer.component';

export default UpdateChatbotDrawer;
